/* eslint-disable */
import React, { useEffect, useState } from "react";
import BossDialog from "../../components/BossDialog";
import * as API from "../../framework/API/api"
import { EMAIL_AUTHTYPE, ENTITYNAME, MODULE, TOAST_TYPES } from "../../framework/constant/constant";
import { DropDownList } from "@progress/kendo-react-dropdowns";
import { EditPageHeader } from "../../components/EditPageHeader";
import { useTranslation } from "../../locale/useTranslation";
import { utility } from "../../framework/utility/utilityProvider";
import ReactQuill from "react-quill";
import AddRoundButton from "../../framework/forms/helpercomponents/buttons/AddRoundButton";
import { Grid, GridColumn } from "@progress/kendo-react-grid";
import RoundButton from "../../framework/forms/helpercomponents/buttons/RoundButton";
import DeleteRoundButton from "../../framework/forms/helpercomponents/buttons/DeleteRoundButton";
import { ConfirmDeleteAlert } from "../../ConfirmAlert";
import ToastNotification from "../../components/ToastNotification";


export const EmailTemplateEditForm = (props) => {
    const lang = useTranslation();
    const blankDataItem = {
        ...props.item,
        SID: props.item.SID ?? 0,
        Description: props.item?.Description ?? '',
        Sender: props.item?.Sender ?? '',
        CC: props.item?.CC ?? '',
        BCC: props.item?.BCC ?? '',
        Subject: props.item?.Subject ?? '',
        TemplateModule: props.item?.TemplateModule ? { _id: props.item.TemplateModule, Description: utility.getKeyByValue(MODULE, props.item.TemplateModule) } : {},
        Body: props.item?.Body ?? '',
        Attachments: props.item?.Attachments ?? [],
    }

    const [dataItem, setDataItem] = useState(blankDataItem);
    const [modules, setModules] = useState([]);
    const [selectedFiles, setSelectedFiles] = useState([]);
    const [senders, setSenders] = useState([]);

    useEffect(() => {
        loadCombo();
    }, [])

    const loadCombo = async () => {
        const moduleRes = Object.keys(MODULE).map(x => ({
            _id: MODULE[x],
            Description: x
        }));
        setModules(moduleRes);
        let senderRes = await API.getDataLookup(ENTITYNAME.EmailConfiguration);
        setSenders(senderRes.data);
    };

    const isValid = () => {
        if (!dataItem.Description || dataItem.Description === "") {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: `${lang.please_enter_description_error_message}` });
            return false;
        }
        if ((Object.keys(dataItem.Sender).length === 0 || !dataItem.Sender)) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: `${lang.please_select_sender_error_message}` });
            return false;
        }
        if (!dataItem.Subject || dataItem.Subject === "") {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: `${lang.please_enter_subject_error_message}` });
            return false;
        }
        if ((Object.keys(dataItem.TemplateModule).length === 0 || !dataItem.TemplateModule)) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: `${lang.please_select_module_error_message}` });
            return false;
        }
        if (!dataItem.Body || dataItem.Body === "") {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: `${lang.please_enter_body_error_message}` });
            return false;
        }
        return true;
    }

    const handleSubmit = async () => {

        if (!isValid()) return;

        try {
            let updatedSelectedFiles = [...selectedFiles];
            let newlyUploadedAttachments = [];

            for (let i = 0; i < updatedSelectedFiles.length; i++) {
                if (!updatedSelectedFiles[i].isUploaded) {
                    let uploadRes = await API.uploadFile(updatedSelectedFiles[i].file);
                    console.log(uploadRes);

                    if (!uploadRes?.success) {
                        ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: uploadRes?.message || lang.unable_to_upload_file_error_message });
                        return;
                    }

                    updatedSelectedFiles[i] = {
                        ...updatedSelectedFiles[i],
                        isUploaded: true,
                        File: uploadRes.data
                    };

                    newlyUploadedAttachments.push({
                        fileName: updatedSelectedFiles[i].fileName,
                        File: uploadRes.data
                    });
                }
            }

            const existingAttachments = Array.isArray(dataItem.Attachments)
                ? dataItem.Attachments.map(x => ({
                    fileName: x.fileName,
                    File: x.File
                }))
                : [];

            const allAttachments = [
                ...existingAttachments,
                ...newlyUploadedAttachments
            ];

            const finalData = {
                _id: dataItem?._id,
                SID: dataItem?.SID ?? 0,
                Description: dataItem?.Description,
                Sender: Object.keys(dataItem?.Sender).length > 0 ? {_id:dataItem?.Sender?._id, Email:dataItem?.Sender?.Email, AppPass : dataItem?.Sender?.AppPass, Service : dataItem?.Sender?.Service} : {},
                CC: dataItem?.CC,
                BCC: dataItem?.BCC,
                Subject: dataItem?.Subject,
                Body: dataItem?.Body,
                TemplateModule: Object.keys(dataItem?.TemplateModule).length > 0 ? dataItem?.TemplateModule?._id : "",
                Attachments: allAttachments
            };
            console.log(finalData);
    
            let res = await API.saveData(ENTITYNAME.EmailTemplate, finalData);

            if (res?.success) {
                ToastNotification({ type: TOAST_TYPES.SUCCESS, title: lang.success_message_title, message: lang.template_saved_successfully_message });
                utility.deleteLocalStorageItem(ENTITYNAME.EmailTemplate);
                props.refresh();
                props.cancelEdit();
            }
            else {
                ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: res?.message || lang.error_saving_template_message });
            }

        } catch (err) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.error_saving_template_message });
        }
    };

    const onChange = (e) => {
        if (e.target.name == "Archive") {
            setDataItem({ ...dataItem, Archive: !dataItem.Archive });
        } else {
            setDataItem({ ...dataItem, [e.target.name]: e.target.value });
        }

    }

    const onFileChange = (e) => {
        const files = Array.from(e.target.files);
        const existingFileNames = dataItem.Attachments.map(file => file.fileName);
        const newFiles = files.filter(file => {
            if (existingFileNames.includes(file.name)) {
                ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.file_already_attached_error_message });
                return false;
            }
            return true;
        }).map(file => ({
            file,
            isUploaded: false,
            fileName: file.name,
            format: file.name.split('.').pop()
        }));

        setSelectedFiles(prev => [...prev, ...newFiles]);
        e.target.value = '';
    };

    const deleteAttachment = async (rowData) => {

        if (rowData._source === 'existing') {
            try {
                let fileName = rowData.fileName;
                let res = await API.deleteFile(fileName);
                if (res?.success) {
                    setDataItem(prev => ({
                        ...prev,
                        Attachments: prev.Attachments.filter(
                            (_, index) => index !== rowData._index
                        )
                    }));
                    ToastNotification({ type: TOAST_TYPES.SUCCESS, title: lang.success_message_title, message: lang.deleted_success_message });
                } else {
                    ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: res?.message || lang.unable_to_delete_file_error_message });
                }
            } catch (error) {
                ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.error_deleting_file_message });
            }
        }
        else if (rowData._source === 'new') {
            setSelectedFiles(prev =>
                prev.filter((_, index) => index !== rowData._index)
            );
        }
    };

    const downloadAttachment = async (rowData) => {

        if (rowData._source === 'existing') {
            try {
                const filePathRes = await API.readFileNameWithContent(rowData.fileName);
                if (filePathRes.success) {
                    let fileUrl = filePathRes.filePath.split('/').pop();
                    await API.downloadFile(fileUrl);
                }
            } catch (error) {
                ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.error_downloading_file_message });
            }
        }

        else if (rowData._source === 'new') {
            const file = rowData.file;
            const url = window.URL.createObjectURL(file);
            const link = document.createElement("a");
            link.href = url;
            link.download = file.name;
            document.body.appendChild(link);
            link.click();
            link.remove();
            window.URL.revokeObjectURL(url);
        }
    };

    const MyCommandCell = (props) => (
        <td>
            <RoundButton icon="download" onClick={() => downloadAttachment(props.dataItem)} />
            <DeleteRoundButton onClick={() => ConfirmDeleteAlert(() => deleteAttachment(props.dataItem), () => { })} />
        </td>
    )

    return (
        <BossDialog
            title={props.item.SID > 0 ? props.item.Description : lang.create_email_template_dialog_header}
            onClose={props.cancelEdit}
            width={"900px"}
        >
            <EditPageHeader title={""} onSubmit={handleSubmit} onCancel={props.cancelEdit} showTitle={false} />
            <div className="row mt-2 form-group">
                <div className="col-6">
                    <label>{lang.description_label} *</label>
                    <input
                        name={"Description"}
                        type="text"
                        className="form-control form-control-sm"
                        onChange={onChange}
                        value={dataItem.Description}
                    />
                </div>
                <div className="col-6">
                    <label>{lang.sender_label} *</label>
                    <DropDownList
                        data={senders}
                        name="Sender"
                        dataItemKey="_id"
                        textField="Email"
                        onChange={onChange}
                        value={dataItem.Sender}
                        style={{ backgroundColor: 'white', height: '32px' }}
                    />
                </div>
            </div>
            <div className="row mt-2 form-group">
                <div className="col-6">
                    <label>{lang.cc_label}</label>
                    <input
                        name={"CC"}
                        type="text"
                        className="form-control form-control-sm"
                        onChange={onChange}
                        value={dataItem.CC}
                    />
                </div>
                <div className="col-6">
                    <label>{lang.bcc_label}</label>
                    <input
                        name={"BCC"}
                        type="text"
                        className="form-control form-control-sm"
                        onChange={onChange}
                        value={dataItem.BCC}
                    />
                </div>
            </div>
            <div className="row mt-2 form-group">
                <div className="col-6">
                    <label>{lang.subject_label} *</label>
                    <input
                        name={"Subject"}
                        type="text"
                        className="form-control form-control-sm"
                        onChange={onChange}
                        value={dataItem.Subject}
                    />
                </div>
                <div className="col-6">
                    <label>{lang.template_module_label} *</label>
                    <DropDownList
                        data={modules}
                        name="TemplateModule"
                        dataItemKey="_id"
                        textField="Description"
                        onChange={onChange}
                        value={dataItem.TemplateModule}
                        style={{ backgroundColor: 'white', height: '32px' }}
                    />
                </div>
            </div>
            <div className="row mt-3">
                <div className="col-12">
                    <label>{lang.body_label} *</label>
                    <ReactQuill
                        theme="snow"
                        value={dataItem.Body}
                        onChange={(content) =>
                            setDataItem({ ...dataItem, Body: content })
                        }
                        style={{ height: "200px", marginBottom: "40px" }}
                    />
                </div>
            </div>
            {dataItem?._id && <>
            <div className='row mt-4'>
                <div className="col-12">
                    <div className='d-flex justify-content-between align-items-center'>
                        <div className="flex items-center">
                            <AddRoundButton
                                name="Add Attachment"
                                onClick={() => document.getElementById('fileInput').click()}
                                title="Add"
                                icon="plus"
                            />
                            <input
                                type="file"
                                id="fileInput"
                                name="creatives"
                                multiple
                                onChange={onFileChange}
                                style={{ display: 'none' }}
                            />
                        </div>
                        <div>{lang.attachments_label}</div>
                    </div>
                    <Grid resizable style={{ height: "200px", marginTop: "5px" }} data={[
                        ...dataItem.Attachments.map((file, i) => ({
                            ...file,
                            _source: 'existing',
                            _index: i,
                            isUploaded: true
                        })),
                        ...selectedFiles.map((fileObj, i) => ({
                            ...fileObj,
                            _source: 'new',
                            _index: i,
                            isUploaded: false
                        }))
                    ]}>
                        <GridColumn cell={MyCommandCell} width={"100px"} locked={true} />
                        <GridColumn field='fileName' title={lang.file_name_column} />
                        <GridColumn field='format' title={lang.format_column} cell={({ dataItem }) => (
                            <td>
                                <div style={{ display: 'flex', alignItems: 'center', height: '100%', textAlign: 'left' }}>
                                    {dataItem && dataItem.format ? dataItem.format.toUpperCase() : ''}
                                </div>
                            </td>
                        )}
                        />
                    </Grid>
                </div>
            </div>
            </>
            }
        </BossDialog>)
};